import { render, staticRenderFns } from "./PythonGIL.vue?vue&type=template&id=530a1535&scoped=true"
import script from "./PythonGIL.vue?vue&type=script&lang=js"
export * from "./PythonGIL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a1535",
  null
  
)

export default component.exports